import React, { useEffect, useState } from "react";
import { Layout, Typography, Row, Col, Button, Card } from "antd";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../service/firebase";

import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import "./BanhoDeOuroSemijoias.css";
import FloatingCTA from "../components/components/common/FloatingCTA.js";
import Reveal from "../components/components/common/Reveal.js";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const whatsappNumber = "5511996064416";

const servicos = [
  {
    title: "Prata Folheada e Flash",
    file: "ouro.png",
  },
  // {
  //   title: "Prata Flash",
  //   file: "banhos/prata-flash.jpg",
  // },
  {
    title: "Prata Velha",
    file: "banhos/prata-velha.jpg",
  },
  {
    title: "Ródio Branco",
    file: "banhos/rodio-branco.jpg",
  },
  {
    title: "Caneta Anódica",
    file: "banhos/Caneta Anódica.jpg",
  },
  {
    title: "Diamante",
    file: "banhos/diamante.jpg",
  },
  // {
  //   title: "Ródio Negro",
  //   file: "banhos/rodio-negro.jpg",
  // },
  {
    title: "Grafite",
    file: "banhos/grafite.jpg",
  },
];

const acabamentos = [
  "Caneta Anódica",
  "Polimento",
  "Pré-aço",
  "Fosco / Jateamento",
];

function BanhoDePrataSemijoias() {
  const [images, setImages] = useState({});

  useEffect(() => {
    async function loadImages() {
      try {
        const urls = {};

        for (const item of servicos) {
          const imageRef = ref(storage, item.file);
          const url = await getDownloadURL(imageRef);
          urls[item.file] = url;
        }

        setImages(urls);
      } catch (error) {
        console.error("Erro ao carregar imagens do Firebase:", error);
      }
    }

    loadImages();
  }, []);

  const getWhatsappLink = (serviceName) => {
    const text = encodeURIComponent(
      `Olá! Quero saber mais sobre o serviço de ${serviceName}.`
    );
    return `https://wa.me/${whatsappNumber}?text=${text}`;
  };

  return (
    <Layout>
      <MainHeader />
      {/* <FloatingCTA triggerId="trigger-floating-cta" /> */}

      <Content>
        <section className="section-banho-ouro">
          <div
            style={{
              maxWidth: 1200,
              margin: "0 auto",
              padding: "48px 20px",
              textAlign: "center",
            }}
          >
            <Reveal>
              <Title
                style={{
                  color: "#fff",
                  fontSize: "clamp(2.2rem, 5vw, 4rem)",
                  lineHeight: 1.1,
                  marginBottom: 16,
                }}
              >
                <span className="p-titulo">Banhos Diversos</span> para semijoias
                com acabamento <span className="p-titulo">premium</span>
              </Title>
            </Reveal>

            <Reveal delay={150}>
              <Paragraph
                style={{
                  color: "#ffffffd9",
                  fontSize: 18,
                  maxWidth: 760,
                  margin: "0 auto",
                }}
              >
                Soluções em banhos especiais para marcas e fabricantes que buscam
                variedade, acabamento refinado e alto padrão de qualidade.
              </Paragraph>
            </Reveal>
          </div>
        </section>

        <section
          style={{
            background: "#f7f7f7",
            padding: "72px 20px",
          }}
        >
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Reveal>
              <Title
                level={2}
                style={{
                  textAlign: "center",
                  marginBottom: 48,
                }}
              >
                Conheça nossos serviços
              </Title>
            </Reveal>

            <Row gutter={[24, 24]}>
              {servicos.map((item, index) => (
                <Col xs={12} sm={12} md={8} key={item.title}>
                  <Reveal delay={200 * (index + 1)} y={24}>
                    <Card
                      hoverable
                      style={{
                        borderRadius: 20,
                        overflow: "hidden",
                        height: "100%",
                        border: "1px solid #ececec",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                      }}
                      bodyStyle={{ padding: 0 }}
                      cover={
                        <div
                          style={{
                            height: 260,
                            background: "#eee",
                            overflow: "hidden",
                          }}
                        >
                          {images[item.file] ? (
                            <img
                              src={images[item.file]}
                              alt={item.title}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#999",
                              }}
                            >
                              Carregando...
                            </div>
                          )}
                        </div>
                      }
                    >
                      <div style={{ padding: 24, textAlign: "center" }}>
                        <Title
                          level={4}
                          style={{
                            marginBottom: 18,
                            color: "#1a1a1a",
                          }}
                        >
                          {item.title}
                        </Title>

                        <a
                          href={getWhatsappLink(item.title)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button className="btn-ouro" size="large">
                            Saiba mais
                          </Button>
                        </a>
                      </div>
                    </Card>
                  </Reveal>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        <section
          id="trigger-floating-cta"
          style={{
            background: "#ffffff",
            padding: "72px 20px",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Reveal>
              <Title
                level={2}
                style={{
                  textAlign: "center",
                  marginBottom: 40,
                }}
              >
                Acabamentos complementares
              </Title>
            </Reveal>

            <Row gutter={[24, 24]}>
              {acabamentos.map((item, index) => (
                <Col xs={24} sm={12} md={8} key={item}>
                  <Reveal delay={200 * (index + 1)} y={20}>
                    <Card
                      hoverable
                      style={{
                        borderRadius: 18,
                        textAlign: "center",
                        border: "1px solid #ececec",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.04)",
                      }}
                    >
                      <Title level={4} style={{ marginBottom: 18 }}>
                        {item}
                      </Title>

                      <a
                        href={getWhatsappLink(item)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button className="btn-ouro">Saiba mais</Button>
                      </a>
                    </Card>
                  </Reveal>
                </Col>
              ))}
            </Row>
          </div>
        </section>
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default BanhoDePrataSemijoias;